// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_dropzone__5jhAB {
  border: 2px dashed #6ba7a8;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  min-height: 150px;
  padding: 1rem;
  cursor: pointer;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.4);
  text-align: center;
  z-index: 5;
}`, "",{"version":3,"sources":["webpack://./src/components/reusable/TranscriptUploader/FileUpload/Dropzone/styles.module.scss"],"names":[],"mappings":"AAAA;EACE,0BAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,iBAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,UAAA;AACF","sourcesContent":[".dropzone {\n  border: 2px dashed #6ba7a8;\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  min-height: 150px;\n  padding: 1rem;\n  cursor: pointer;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.4);\n  text-align: center;\n  z-index: 5;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dropzone": `styles_dropzone__5jhAB`
};
export default ___CSS_LOADER_EXPORT___;
